import { useEffect, useState } from "react";

// Keep track of mounted state.
const useIsMounted = (): boolean => {
  const [isMounted, setMounted] = useState<boolean>(false);

  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);

  return isMounted;
};

export { useIsMounted };
